import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import Header from '../components/common/Header';
import Footer from '../components/common/Footer';
import { ArrowLeft } from 'lucide-react';

const BACKEND = process.env.REACT_APP_BACKEND_URL;

export default function ArticlePage() {
  const { slug } = useParams();
  const [article, setArticle] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${BACKEND}/api/blog/${slug}`)
      .then(r => r.json())
      .then(d => setArticle(d))
      .catch((err) => { /* eslint-disable-line no-empty */ })
      .finally(() => setLoading(false));
  }, [slug]);

  if (loading) return <div style={{ background: 'var(--bg, #FBF7F1)', minHeight: '100vh' }}><Header /></div>;
  if (!article) return <div style={{ background: 'var(--bg, #FBF7F1)', minHeight: '100vh' }}><Header /><div className="container-ose pt-20 text-center"><p style={{ color: 'var(--text-muted)' }}>Article non trouvé</p></div><Footer /></div>;

  return (
    <div style={{ background: 'var(--bg, #FBF7F1)', minHeight: '100vh' }}>
      <Header />
      <div className="container-ose section-py" style={{ maxWidth: '760px' }}>
        <Link to="/blog" className="flex items-center gap-2 text-sm mb-6" style={{ color: 'rgba(26,26,46,0.5)' }}>
          <ArrowLeft size={16} /> Blog
        </Link>
        {article.image && <img src={article.image} alt={article.titre} className="w-full h-64 object-cover rounded-2xl mb-6" loading="lazy" />}
        <div className="flex flex-wrap gap-2 mb-4">
          {article.tags?.map(t => <span key={t} className="px-2 py-1 rounded-full text-xs" style={{ background: 'rgba(197,216,249,0.15)', color: '#C5D8F9' }}>{t}</span>)}
          {article.localite && <span className="px-2 py-1 rounded-full text-xs" style={{ background: 'rgba(212,175,55,0.15)', color: '#D4AF37' }}>{article.localite}</span>}
        </div>
        <h1 className="font-display text-2xl sm:text-3xl font-bold mb-4" style={{ color: 'var(--text)', letterSpacing: '-0.02em' }}>{article.titre}</h1>
        <p className="text-base mb-8" style={{ color: 'rgba(255,255,255,0.6)' }}>{article.extrait}</p>
        <div className="prose text-sm" style={{ color: 'rgba(255,255,255,0.75)', lineHeight: '1.8', whiteSpace: 'pre-line' }}>
          {article.contenu}
        </div>
      </div>
      <Footer />
    </div>
  );
}
